<template>
    <v-row>
      <v-col :cols="cols">
        <v-select
          v-model="measures"
          :items="dimensions"
          :menu-props="{ maxHeight: '400' }"
          :label="label"
          multiple
          :hint="hint"
          chips
          persistent-hint
        ></v-select>
      </v-col>
      <horizontal-bar :cols="cols" :dimensions="selectedMeasures" :aggregatedValues="aggregatedData" />
    </v-row>
</template>

<script>
import HorizontalBar from "../components/HorizontalBar.vue";
import { SET_MEASURES } from "../mutation-types";
import { mapGetters } from "vuex";
export default {
  computed: {
    orderedDimensions() {
      return this.$store.getters.points.map(p => {
        return p.name;
      });
    },
    measures: {
      get() {
        return this.selectedMeasures;
      },
      set(measures) {
        this.$store.commit(SET_MEASURES, measures);
      }
    },
    ...mapGetters(["aggregatedData", "dimensions", "selectedMeasures"])
  },
  data() {
    return {
      cols: 12,
      selection: [],
      label: "選択",
      hint: "ディメンションを選択しましょう"
    };
  },
  mounted() {
    this.$nextTick(function() {
      this.selection = this.selectedMeasures
    });
  },
  components: {
    HorizontalBar
  },
  methods: {
  }
};
</script>